import Icon, {iconTypes} from "../../../common/components/Icon.jsx";
import React, {Component} from "react";
import {Tag, tagTypes} from "../../../common/components/Tag.jsx";
import {Localization} from "../../../common/util/localization.jsx";

import PropTypes from "prop-types";

class FaqAccordion extends Component {
    constructor(props){
        super(props);

        this.state = {
            expanded: false
        };

        this.toggleExpand = this.toggleExpand.bind(this);
    }

    toggleExpand(e) {
        e.stopPropagation();

        this.setState({
            expanded: !this.state.expanded,
        });
    }

    render() {
        const {
            children,
            label,
            localization,
            count
        } = this.props;
        return(
            <div className="faq-accordion-wrapper">
                <div className="main-header" onClick={this.toggleExpand}>
                    <Icon type={iconTypes.boxQuestion} className="icon" style={{zIndex: 0}}/>
                    <div className="label">
                        {label}
                    </div>
                    <Tag className="tag" type={tagTypes.grey} label={localization.text("help", "questionCount", {count: count})} />
                    {this.state.expanded ? (
                        <Icon type={iconTypes.up} className="icon" style={{zIndex: 0}}/>
                    ) : (
                        <Icon type={iconTypes.down} className="icon" style={{zIndex: 0}}/>
                    )}
                </div>
                {this.state.expanded && (
                    children
                )}
            </div>
        );
    }
}

FaqAccordion.propTypes = {
    children: PropTypes.node.isRequired,
    label: PropTypes.string.isRequired,
    localization: Localization.propTypes.isRequired,
    count: PropTypes.number.isRequired,
};

export default FaqAccordion;
